import React, { PropsWithChildren, useState } from 'react';
import { Marker, InfoWindow } from '@react-google-maps/api';
import { Coordinates } from 'interfaces/vector.interface';
import './index.css';
import { IMachineIcon } from 'interfaces/maps.interface';
interface Props {
	handleClick: any;
	position: Coordinates;
	icon: IMachineIcon | google.maps.Symbol;
}
const GenericMarker = (props: PropsWithChildren<Props>) => {
	const [showInfoWindow, setShowInfoWindow] = useState(false);
	return (
		<div>
			<Marker
				icon={props.icon}
				onMouseOver={() => {
					setShowInfoWindow(true);
				}}
				onMouseOut={() => {
					setShowInfoWindow(false);
				}}
				position={props.position}
				onClick={props.handleClick}
			></Marker>
			{showInfoWindow && (
				<InfoWindow
					options={{
						disableAutoPan: true,
						zIndex: 2,
						pixelOffset: new google.maps.Size(-5, -10),
					}}
					onCloseClick={() => {
						setShowInfoWindow(false);
					}}
					position={props.position}
				>
					{props.children}
				</InfoWindow>
			)}
		</div>
	);
};

export default GenericMarker;
